// extracted by mini-css-extract-plugin
export default {"container":"fire-dispatch-status_container__sNCtG"};